import * as React from "react";
import { ItemContainer, ItemDate, ItemName, ItemStatistics } from "./HistoryPage.styled";
import { HistoryLessonI } from "../../interfaces/history";
import dayjs from "dayjs";
import { CircleProgressBar } from "../../components/common";

interface ItemProps {
	lesson: HistoryLessonI;
}

export const Item = ({ lesson }: ItemProps) => {
	const numberLesson = lesson.lesson_name.match(/\d+/)?.[0] ?? "";

	return (
		<ItemContainer>
			<ItemDate>{dayjs(lesson.start_lesson).format("h:mm a")}</ItemDate>

			<CircleProgressBar
				strokeWidth={2}
				sqSize={44}
				percentage={lesson.progress_percent}
				payload={numberLesson}
				color={"#fff"}
			/>

			<ItemName>{lesson.lesson_name}</ItemName>

			<ItemStatistics>
				Studied for <span>{lesson.progress_minute} min</span>
			</ItemStatistics>
		</ItemContainer>
	);
};
